export default "__VITE_ASSET__CpvzaYVm__"